import defaultClient from '@src/api/clients/default';

export function fetchBudgetPacing(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing/',
    payload,
  });
}

export function fetchBudgetPacingOverall(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-overall/',
    payload,
  });
}

export function fetchBudgetPacingSegments(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/pacing-segments/',
    payload,
  });
}

export function fetchBudgetCenter(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/',
    payload,
  });
}

export function saveBudgetCenterDraft(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/save-draft/',
    method: 'POST',
    payload,
  });
}

export function approveBudgetCenter(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/approve/',
    method: 'POST',
    payload,
  });
}

export function discardBudgetCenterDraft(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/discard/',
    method: 'POST',
    payload,
  });
}

export function markBudgetCenterLive(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/mark-live/',
    method: 'POST',
    payload,
  });
}

export function fetchAvailableMonths(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/available-months/',
    payload,
  });
}

export function copyFromMonth(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/copy-from-month/',
    method: 'POST',
    payload,
  });
}

export function fetchBudgetComments(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/comments/',
    payload,
  });
}

export function postBudgetComment(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/comments/',
    method: 'POST',
    payload,
  });
}

export function fetchBudgetSubmissions(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/client-budgets/budget-center/submissions/',
    payload,
  });
}

export default {
  fetchBudgetPacing,
  fetchBudgetPacingOverall,
  fetchBudgetPacingSegments,
  fetchBudgetCenter,
  saveBudgetCenterDraft,
  approveBudgetCenter,
  discardBudgetCenterDraft,
  markBudgetCenterLive,
  fetchAvailableMonths,
  copyFromMonth,
  fetchBudgetComments,
  postBudgetComment,
  fetchBudgetSubmissions,
};
